import React from "react";

const Behance = ({fill}) => {
  return (
    <svg
      width="30"
      height="21"
      viewBox="0 0 30 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.25 0.25H5.78049C8.83489 0.25 11.311 2.72608 11.311 5.78049C11.311 7.41412 10.6027 8.88233 9.4764 9.89474C12.0711 10.3509 14.0427 12.616 14.0427 15.3415C14.0427 18.3959 11.5666 20.872 8.5122 20.872H0.25V0.25ZM1.75 11.311V19.372H8.5122C10.7382 19.372 12.5427 17.5674 12.5427 15.3415C12.5427 13.1155 10.7382 11.311 8.5122 11.311H1.75ZM1.75 9.81098H5.78049C8.00646 9.81098 9.81098 8.00647 9.81098 5.78049C9.81098 3.55451 8.00646 1.75 5.78049 1.75H1.75V9.81098ZM15.9573 3.73171C15.9573 3.31749 16.2931 2.98171 16.7073 2.98171H29C29.4142 2.98171 29.75 3.31749 29.75 3.73171C29.75 4.14592 29.4142 4.48171 29 4.48171H16.7073C16.2931 4.48171 15.9573 4.14592 15.9573 3.73171ZM16.6402 14.6585C16.6402 11.227 19.4221 8.44512 22.8537 8.44512C26.2852 8.44512 29.0671 11.227 29.0671 14.6585V15.4085H18.1996C18.5588 17.6552 20.5058 19.372 22.8537 19.372C23.855 19.372 24.7813 19.0606 25.544 18.5293C25.8839 18.2926 26.3513 18.3762 26.5881 18.7161C26.8248 19.056 26.7412 19.5234 26.4013 19.7602C25.3952 20.461 24.1713 20.872 22.8537 20.872C19.4221 20.872 16.6402 18.0901 16.6402 14.6585ZM18.1996 13.9085H27.5077C27.1485 11.6618 25.2016 9.94512 22.8537 9.94512C20.5058 9.94512 18.5588 11.6618 18.1996 13.9085Z"
        fill={fill}
      ></path>
    </svg>
  );
};

export default Behance;
